(function () {
  'use strict';

  function updateCartPillCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-pga-cart-link]').forEach(function (el) {
          el.textContent = 'Cart (' + cart.item_count + ')';
        });
      });
  }

  /* Mobile nav drawer */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-pga-menu-toggle]');
    if (!toggle) return;
    var header = toggle.closest('.pga-header');
    var drawer = header ? header.parentElement.querySelector('[data-pga-mobile-drawer]') : document.querySelector('[data-pga-mobile-drawer]');
    if (!drawer) return;
    var isOpen = drawer.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  /* Header search: toggle panel + predictive results */
  (function () {
    var toggle = document.querySelector('[data-pga-search-toggle]');
    var panel = document.querySelector('[data-pga-search-panel]');
    var input = document.querySelector('[data-pga-search-input]');
    var closeBtn = document.querySelector('[data-pga-search-close]');
    var resultsEl = document.querySelector('[data-pga-search-results]');
    if (!toggle || !panel || !input) return;

    function openPanel() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      input.focus();
    }
    function closePanel() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (panel.hidden) { openPanel(); } else { closePanel(); }
    });
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) closePanel();
    });
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      closePanel();
    });

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }
    function formatMoney(price) {
      var n = parseFloat(price);
      return isNaN(n) ? '' : '$' + n.toFixed(2);
    }
    function renderGroup(label, items, rowBuilder) {
      if (!items || !items.length) return '';
      var html = '<div class="pga-search-group"><div class="pga-search-group__label">' + label + '</div>';
      items.forEach(function (item) { html += rowBuilder(item); });
      return html + '</div>';
    }
    function renderResults(data, query) {
      var results = (data.resources && data.resources.results) || {};
      var products = results.products || [];
      var pages = results.pages || [];
      var articles = results.articles || [];
      if (!products.length && !pages.length && !articles.length) {
        return '<div class="pga-search-empty">No results for &ldquo;' + escapeHtml(query) + '&rdquo;.</div>';
      }
      var html = '';
      html += renderGroup('Products', products, function (p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        return '<a href="' + p.url + '" class="pga-search-row">' +
          '<div class="pga-search-row__media">' + (img ? '<img src="' + img + '" width="60" height="60" loading="lazy" alt="' + escapeHtml(p.title) + '">' : '') + '</div>' +
          '<div><div class="pga-search-row__title">' + escapeHtml(p.title) + '</div><div class="pga-search-row__price">' + formatMoney(p.price) + '</div></div>' +
          '</a>';
      });
      html += renderGroup('Pages', pages, function (pg) {
        return '<a href="' + pg.url + '" class="pga-search-row pga-search-row--text">' + escapeHtml(pg.title) + '</a>';
      });
      html += renderGroup('Journal', articles, function (a) {
        return '<a href="' + a.url + '" class="pga-search-row pga-search-row--text">' + escapeHtml(a.title) + '</a>';
      });
      html += '<a href="/search?q=' + encodeURIComponent(query) + '&type=product,page,article" class="pga-search-view-all">View all results for &ldquo;' + escapeHtml(query) + '&rdquo; &rarr;</a>';
      return html;
    }

    var debounceTimer;
    input.addEventListener('input', function () {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        if (resultsEl) resultsEl.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,article&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (resultsEl) resultsEl.innerHTML = renderResults(data, query);
          })
          .catch(function () {});
      }, 200);
    });
  })();

  /* PDP: size/variant selection */
  document.querySelectorAll('[data-pga-product-form]').forEach(function (form) {
    var variantInput = form.querySelector('[data-pga-variant-id]');
    var atcButton = form.querySelector('[data-pga-atc]');
    var atcPriceEl = atcButton ? atcButton.querySelector('[data-pga-atc-price]') : null;
    var priceDisplay = form.closest('.pga-pdp') ? form.closest('.pga-pdp').querySelector('[data-pga-atc-price-display]') : null;

    form.querySelectorAll('.pga-size-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.hasAttribute('disabled')) return;
        form.querySelectorAll('.pga-size-pill').forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        if (variantInput) variantInput.value = pill.getAttribute('data-variant-id');
        if (atcButton) atcButton.disabled = false;
        if (atcPriceEl && pill.getAttribute('data-variant-price')) {
          atcPriceEl.textContent = pill.getAttribute('data-variant-price');
        }
        if (priceDisplay && pill.getAttribute('data-variant-price')) {
          priceDisplay.textContent = pill.getAttribute('data-variant-price');
        }
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variantInput || !variantInput.value) return;
      if (atcButton) {
        atcButton.disabled = true;
        atcButton.setAttribute('data-original-label', atcButton.getAttribute('data-original-label') || atcButton.innerHTML);
        atcButton.innerHTML = 'Adding&hellip;';
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          updateCartPillCount();
          if (atcButton) {
            atcButton.innerHTML = 'Added to cart ✓';
            setTimeout(function () {
              atcButton.innerHTML = atcButton.getAttribute('data-original-label');
              atcButton.disabled = false;
            }, 1800);
          }
        })
        .catch(function () {
          if (atcButton) {
            atcButton.innerHTML = atcButton.getAttribute('data-original-label');
            atcButton.disabled = false;
          }
        });
    });
  });

  /* PDP: gallery thumb click swaps the main image */
  document.querySelectorAll('[data-pga-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = thumb.closest('.pga-gallery');
      if (!gallery) return;
      var main = gallery.querySelector('[data-pga-gallery-main] img');
      var fullSrc = thumb.getAttribute('data-full-src');
      if (main && fullSrc) main.src = fullSrc;
    });
  });

  /* PDP: related products, loaded via Shopify's product recommendations endpoint */
  document.querySelectorAll('[data-pga-related-root]').forEach(function (root) {
    var url = root.getAttribute('data-pga-related-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshGrid = doc.querySelector('[data-pga-related-grid], .pga-grid');
        var ownGrid = root.querySelector('[data-pga-related-grid]');
        if (freshGrid && freshGrid.children.length && ownGrid) {
          ownGrid.innerHTML = freshGrid.innerHTML;
        } else {
          root.remove();
        }
      })
      .catch(function () { root.remove(); });
  });

  /* Cart page: quantity stepper + remove, re-rendered via Section Rendering API */
  var cartRoot = document.getElementById('pga-cart-items');

  function refreshCartSection() {
    var url = window.location.pathname + '?sections=main-cart';
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['main-cart'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('pga-cart-items');
        if (fresh && cartRoot) {
          cartRoot.innerHTML = fresh.innerHTML;
        }
        updateCartPillCount();
      });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(refreshCartSection);
  }

  if (cartRoot) {
    cartRoot.addEventListener('click', function (e) {
      var stepBtn = e.target.closest('[data-pga-qty-step]');
      if (stepBtn) {
        var line = parseInt(stepBtn.getAttribute('data-line'), 10);
        var delta = parseInt(stepBtn.getAttribute('data-pga-qty-step'), 10);
        var currentQty = parseInt(stepBtn.parentElement.querySelector('[data-pga-qty-val]').textContent, 10);
        var next = Math.max(0, currentQty + delta);
        changeLine(line, next);
        return;
      }
      var removeBtn = e.target.closest('[data-pga-remove-line]');
      if (removeBtn) {
        e.preventDefault();
        var removeLine = parseInt(removeBtn.getAttribute('data-line'), 10);
        changeLine(removeLine, 0);
      }
    });
  }

  /* Cart page: discount code apply (redirects through Shopify's discount route) */
  document.querySelectorAll('[data-pga-discount-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var code = input && input.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    });
  });

  /* FAQ accordions: close siblings within the same category for a cleaner single-open UX (optional, non-blocking) */
  document.querySelectorAll('[data-pga-faq-group]').forEach(function (group) {
    var items = group.querySelectorAll('details.pga-faq-item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });
})();
